import React, { PropTypes } from 'react';

import * as upgradeConstants from '../../stores/ui/components/upgrade/upgrade-constants';

import NotificationsActive from 'material-ui/svg-icons/social/notifications-active';
import HappyMood from 'material-ui/svg-icons/social/mood';
import GroupAdd from 'material-ui/svg-icons/social/group-add';
import EventAvailable from 'material-ui/svg-icons/notification/event-available';
import MobileAppIcon from 'material-ui/svg-icons/hardware/smartphone';

import TCIcon from '../tc-ui/icon';

import PlanItem from './PlanItem';

const PlanItems = ({ companyType, upgradeReason }) => {
  const planItems = [
    {
      title: 'Year-Round Trade Show',
      content: 'We all know how expensive trade events can be. With TourConnect, have a trade show at your fingertips all day, every day...for a fraction of the cost.',
      icon: <EventAvailable />,
      backgroundColor: '#2196F3',
      upgradeReasons: [upgradeConstants.PARTNER_FINDER_CONNECT],
    },
    {
      title: 'Getting Maximum Value',
      content: 'While we take pride in helping you connect with great companies, you still need to put the work in to produce bookings. Remember to follow up with new connections, and start building a relationship!',
      icon: <NotificationsActive />,
      backgroundColor: '#2196F3',
      upgradeReasons: [upgradeConstants.PARTNER_FINDER_CONNECT],
    },
    {
      title: 'No Contracts - Cancel Anytime',
      content: 'You can downgrade or cancel your account at any time, and you will not be charged from that point onward. It\'s that simple.',
      icon: <HappyMood />,
      backgroundColor: '#2196F3',
      upgradeReasons: [upgradeConstants.PARTNER_FINDER_CONNECT],
    },
    {
      title: 'Our Goal for Your Upgrade',
      content: 'Our goal is to get you at least one new partner per year. Business partnerships can last for years, so that one new partner can pay off for years to come.',
      icon: <GroupAdd />,
      backgroundColor: '#2196F3',
      upgradeReasons: [upgradeConstants.PARTNER_FINDER_CONNECT],
    },
    {
      title: 'Mobile App',
      content: <span>Make following up at trade events a breeze by using the mobile app with business card scanner to instantly send follow ups. <i>(Special Offer: Unlimited app users for accounts paying annually)</i></span>,
      icon: <MobileAppIcon/>,
      iconStyle: { fontSize: '34px', lineHeight: '76px' },
      backgroundColor: '#2196F3',
      upgradeReasons: [upgradeConstants.PARTNER_FINDER_CONNECT],
    },
    {
      title: 'Partner Finder',
      content: 'With PartnerFinder, you\'ll get access to the entire TourConnect network to search for new partners and a priority listing on PartnerFinder.',
      icon: <TCIcon className={`tc-icon-partner-finder`} />,
      iconStyle: { fontSize: '34px', lineHeight: '76px' },
      backgroundColor: 'rgb(255, 138, 11)',
    },
    {
      title: 'Partner Management',
      content: 'Manage all of your B2B partners in one place. Ensure everyone on your team knows who your partners are, and your history with them, so you can get more out of your relationships',
      icon: <TCIcon className={`tc-icon-people`} />,
      iconStyle: { fontSize: '34px', lineHeight: '76px' },
      backgroundColor: 'rgb(108, 129, 239)',
    },
    {
      title: 'Marketing Manager',
      content: 'Marketing Materials is your marketing asset respository for your partners to access up-to-date brochures, images, or videos.',
      icon: <TCIcon className={`tc-icon-marketing-materials`} />,
      iconStyle: { fontSize: '34px', lineHeight: '76px' },
      backgroundColor: 'rgb(0, 210, 78)',
    },
    {
      title: 'Mobile App',
      content: <span>Make following up at trade events a breeze by using the mobile app with business card scanner to instantly send follow ups. <i>(Special Offer: Unlimited app users for accounts paying annually)</i></span>,
      icon: <MobileAppIcon/>,
      iconStyle: { fontSize: '34px', lineHeight: '76px' },
      backgroundColor: '#ce93d8',
    },
    {
      title: 'And Much More...',
      content: 'Features like message tracking, internal notes, new supplier alerts, and more!',
      icon: <TCIcon className={`tc-icon-star`} />,
      iconStyle: { fontSize: '34px', lineHeight: '76px' },
      backgroundColor: 'rgb(255, 214, 11)',
    },
  ];
  const upgradeReasonsBeingHandled = [upgradeConstants.PARTNER_FINDER_CONNECT];

  return (
    <div>
      <h4 style={{ fontWeight: 300, textAlign: 'center' }}>The Details</h4>
      <ul style={{ display: 'flex', flexWrap: 'wrap' }}>
        {
        planItems
        .filter(plan => {
          if (upgradeReasonsBeingHandled.indexOf(upgradeReason) > -1) return (plan.upgradeReasons && plan.upgradeReasons.indexOf(upgradeReason) > -1);
          return !plan.upgradeReasons;
        })
        .map((plan, i, arr) => <PlanItem {...plan} key={i} style={i === arr.length -1 ? { display: 'block', margin: 'auto' } : {}} />)
        }
      </ul>
    </div>
  );
};

PlanItems.propTypes = {
  plan: PropTypes.object,
  companyType: PropTypes.string,
  onUpgradeClick: PropTypes.func,
};

export default PlanItems;



// WEBPACK FOOTER //
// ./src/app/components/upgrade/PlanItems.jsx